export class Country {
  constructor(public _id: number, public country_name: string) { }
}

export class Country1 {
country_name: string;
currency_code: string;
currency_type: string;
// constructor(public key: string, public country_name: string) { }
}